export function SetupView() {
  return (
    <div className="viewer">
      <div className="viewer__setup">
        <div className="viewer__setup-content">
          <svg className="viewer__setup-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z" />
            <path d="M8 2v16" />
            <path d="M16 6v16" />
          </svg>

          <h3 className="viewer__setup-title">No Map Data Available</h3>
          <p className="viewer__setup-description">Orthomosaic and DSM data will appear here once processed and added to this project.</p>
        </div>
      </div>
    </div>
  );
}
